import { useEffect, useState } from "react"
import { fetchDynamicFeedData, type DynamicFeedData } from "@/lib/dynamicData"

// --- simple in-memory cache so multiple components share one fetch ---
let cachedData: DynamicFeedData | null = null
let pendingPromise: Promise<DynamicFeedData | null> | null = null

export function useDynamicData() {
  const [data, setData] = useState<DynamicFeedData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)

  useEffect(() => {
    if (cachedData) {
      setData(cachedData)
      setLoading(false)
      return
    }

    setLoading(true)

    // Ensure we only kick off ONE network request even if many hooks mount simultaneously.
    if (!pendingPromise) {
      pendingPromise = fetchDynamicFeedData().then(result => {
        cachedData = result
        return result
      })
    }

    pendingPromise
      .then(result => {
        console.log('Fetched dynamic data:', result) // Debug log
        setData(result)
      })
      .catch(err => {
        console.error("Failed to load dynamic feed data", err)
        setError(err)
      })
      .finally(() => setLoading(false))
  }, []) // Empty dependency array since we only need to fetch once

  return { data, loading, error }
}